import React, { useState } from 'react';

export default function SettingsTab() {
    const [email] = useState('Baran.Masoumian@gmail.com');

    return (
        <div className="w-full flex justify-center">
            <div className="flex min-h-fit w-full flex-col gap-4 rounded-[28px] bg-white p-3 ring-1 ring-black/[0.06] dark:bg-white/[0.04] dark:ring-white/10 sm:p-4">
                {/* Newsletter subscription */}
                {/* <div>
                    <div className="text-base font-semibold text-[#222] mb-2">Newsletter subscription:</div>
                    <div className="text-sm text-[#888] mb-4">By cancelling your subscription, updates and news will no longer send to your email.</div>
                    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                        <input
                            type="email"
                            value={email}
                            disabled
                            className="w-full sm:w-[340px] px-4 py-3 rounded border border-gray-100 bg-[#F6F6F6] text-[#888] text-base font-medium focus:outline-none cursor-not-allowed"
                        />
                        <button className="w-full sm:w-auto px-6 py-3 rounded bg-[#E53935] text-white font-semibold text-base hover:bg-[#c62828]">Cancel My Subscription</button>
                    </div>
                </div>
                <hr className="my-2 border-gray-100" /> */}
                {/* Delete account */}
                <div className="flex flex-col gap-4 rounded-[20px] bg-grey99 p-5 dark:bg-white/[0.04] sm:flex-row sm:items-center sm:justify-between sm:p-6">
                    <div className="min-w-0">
                        <div className="text-lg font-bold tracking-[-0.02em] text-[#E53935]">Delete account</div>
                        <div className="mt-1 text-sm text-grey40 dark:text-nightMuted">This action will permanently delete your account!</div>
                    </div>
                    <button className="inline-flex h-12 w-full shrink-0 items-center justify-center rounded-full bg-[#E53935] px-6 text-sm font-semibold text-white transition-colors hover:bg-[#c62828] sm:w-auto">Delete My Account</button>
                </div>
            </div>
        </div>
    );
} 